import { LanguageCode } from "../../i18n/language";
import { contactResource, ContactResourceTranslations } from "./components/contact/Contact.i18n.ts";
import { socialsResource, SocialsResourceTranslations } from "./components/socials/Socials.i18n.ts";

/**
 * Overall footer translation resources structure.
 */
export interface FooterResourceTranslations {
    contact: ContactResourceTranslations;
    socials: SocialsResourceTranslations;
}

/**
 * Overall footer translation resources structure.
 */
type FooterResource = {
    [language in LanguageCode]: FooterResourceTranslations;
};  

export const footerResource: FooterResource = {
    nl: {
        contact: contactResource.nl,
        socials: socialsResource.nl
    },
    en: {
        contact: contactResource.en,
        socials: socialsResource.en
    }
};